<template>
  <div class="x-upload-list">
    <template v-for="file in uploadList">
      <div class="upload-list-item" :key="file.id" @click="handleDownload(file)">
        <div class="list-item--icon">
          <x-svg-icon v-if="file.status === 'pending'" class="animate-rotate"  name="x-lib-loading"></x-svg-icon>
          <template v-else>
            <img v-if="file.fileType === 'image'" :src="file.src" @click.stop="showImagePreview(file)">
            <x-svg-icon v-if="file.fileType === 'pdf'" name="x-lib-pdf"></x-svg-icon>
            <x-svg-icon v-if="file.fileType === 'excel'" name="x-lib-excel"></x-svg-icon>
            <x-svg-icon v-if="file.fileType === 'word'" name="x-lib-word"></x-svg-icon>
            <x-svg-icon v-if="file.fileType === 'compressed'" name="x-lib-zip"></x-svg-icon>
            <x-svg-icon v-if="file.fileType === 'video'" name="x-lib-video"></x-svg-icon>
            <x-svg-icon v-if="file.fileType === 'unknown'" name="x-lib-unknown"></x-svg-icon>
            <x-svg-icon v-if="file.fileType === 'ppt'" name="x-lib-ppt"></x-svg-icon>
          </template>
        </div>
        <div class="list-item--info">
          <span class="list-item--name text-overflow">{{ file.fileName }}</span>
          <span class="list-item--size">{{ file.fileSizeStr }}</span>
        </div>
        <div v-if="file.status === 'pending'" class="list-item--cancal" @click.stop="cancalUploadFile(file)">
          取消
        </div>
        <div v-else-if="file.status === 'completed' && renderSence !== 'read' && !readOnly" class="list-item--status" @click.stop="handleRemove(file)">
          <!-- <x-svg-icon v-if="file.status === 'pending'" class="animate-rotate"  name="x-lib-loading"></x-svg-icon> -->
          <x-svg-icon name="x-lib-delete"></x-svg-icon>
        </div>
      </div>
    </template>
    <x-empty v-if="uploadList.length === 0"></x-empty>
  </div>
</template>

<script>
import XEmpty from '../../x-empty/x-empty'
export default {
  components: {
    XEmpty
  },
  props: {
    uploadList: {
      type: Array,
      default() {
        return []
      }
    },
    renderSence: {
      type: String,
      default: 'edit',
      validator(value) {
        return ['edit', 'read'].indexOf(value) !== -1
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imgs() {
      return this.uploadList.filter(item => item.fileType === 'image')
    }
  },
  data() {
    return {
      previewIdx: 0
    }
  },
  methods: {
    handleRemove(file) {
      if (file.status === 'completed' && this.renderSence !== 'read' && !this.readOnly) {
        this.$emit('remove', file)
      }
    },
    handleDownload(file) {
      this.$emit('download', file)
    },
    showImagePreview(file) {
      this.previewIdx = this.imgs.indexOf(file)
      if (this.previewIdx !== -1) {
        this.$createImagePreview({
          $props: {
            imgs: this.imgs.map(item => item.src),
            initialIndex: 'previewIdx'
          },
          $events: {
            change: (idx) => {
              this.previewIdx = idx
            }
          }
        }).show()
      }
    },
    cancalUploadFile(file) {
      this.$emit('cancalUploadFile', file)
    }
  }
}
</script>

<style lang="scss">
.x-upload-list {
  width: 100%;
  .upload-list-item {
    display: flex;
    align-items: center;
    padding: 0.71rem 0;
    width: calc(100vw - 1.14rem);
    box-sizing: border-box;
    border-bottom: 1PX solid $--app-form-item-border-color;
    &:last-child {
      padding-bottom: 0;
      border: 0;
    }
    .list-item--icon {
      flex: 0 0 2.86rem;
      width: 2.86rem;
      height: 2.86rem;
      img, .x-svg-icon,.x-svg-icon .svg-icon {
        width: 100% !important;
        height: 100% !important;
      }
      .animate-rotate {
        animation: loading-rotate 1s linear infinite;
      }
    }
    .list-item--info {
      display: flex;
      flex: 1;
      flex-direction: column;
      margin: 0 0.57rem;
      max-width: calc(100% - 2.86rem - 3.43rem - 1.14rem);
      .list-item--name {
        font-size: $--app-title-font-size;
        margin-bottom: 0.57rem;
      }
      .list-item--size {
        font-size: $--app-base-font-size;
        color: $--app-notice-font-color;
      }
    }
    .list-item--status {
      flex: 0 0 3.43rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3.43rem;
      height: 2.86rem;
      font-size: 0;
      color: $--app-base-font-color;
    }
    .list-item--cancal {
      flex: 0 0 3.43rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3.43rem;
      height: 2.86rem;
      font-size: $--app-base-font-size;
      color: $--app-notice-color;
    }
  }
}

@keyframes loading-rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>